<template>
    <span v-if="teams && teams.length" style="margin-left:-6px;">
        <!-- Show only the first team -->
        <v-chip small>
            {{ teams[0] }}
        </v-chip>

        <!-- Show a "+ n more" chip if more than one team -->
        <v-chip small v-if="teams.length > 1" :title="teams.slice(1).join(', ')">
            + {{ teams.length - 1 }} more
        </v-chip>
    </span>
</template>
<script>

export default {
    props: ['teams']
}
</script>